<div class="grid-container margin-top">
    <div class="grid-x grid-margin-x">
        <div class="cell small-12 medium-4 flex flex-align-items-center">
            <label for="fromDateModel" class="margin-right">Start:</label>
            <common-date-picker [id]="'fromDate'" [placeholder]="placeholder" (dateUpdated)="fromDateChange($event)" [initialDate]="fromDate" [futureDateLimit]="futureDateLimit"></common-date-picker>
        </div>
        <div class="cell small-12 medium-4 medium-text-center flex flex-align-items-center">
            <label for="toDateModel" class="margin-right">End:</label>
            <common-date-picker [id]="'toDate'" [placeholder]="placeholder" (dateUpdated)="toDateChange($event)" [initialDate]="toDate" [pastDateLimit]="pastDateLimit"></common-date-picker>
        </div>
        <div class="cell small-12 medium-4 medium-text-right flex flex-align-items-center">
            <label class="margin-right">Success:</label>
            <select id="slc-success" class="flex-grow-1" [(ngModel)]="successFilter">
                <option value="0">Both Successful &amp; Failed</option>
                <option value="1">Only Successful</option>
                <option value="2">Only Failed</option>
            </select>
        </div>
        <div class="cell small-6">
            <button class="button" [disabled]="filterDisabled" (click)="search()">Filter</button>
        </div>
        <div class="cell small-6 text-right">
            <button class="button no-margin-bottom" (click)="downloadReport()">Download Report</button>
            <a style="display:none" #downloadLink></a>
        </div>
        <div class="cell">
            <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data" [excelStyles]="excelStyles" aria-label="Login Auth"></ag-grid-angular>
        </div>
    </div>
</div>
